<template>
  <div class="p-3 bg-white">
    <div id="announcementAddFormDataContainer" class="vs-con-loading__container">
        <shared-announcement-add
          @success="onStoreSuccess"
        ></shared-announcement-add>

      <div class="text-center">
        <vs-button id="addAnnouncementButton" class="m-2" color="primary" type="filled" @click.prevent="storeAnnouncement">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddAnnouncement">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import SharedAnnouncementAdd from '@/views/Shared/Announcement/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Dashboard.Announcement.Add',
  components: {
    SharedAnnouncementAdd
  },
  mounted () {
    EventBus.$emit('initAnnouncementResetFormData')
  },
  methods: {
    storeAnnouncement () {
      EventBus.$emit('initSaveAnnouncement')
    },
    onStoreSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_announcements_table')
      window.close()
    },
    cancelAddAnnouncement () {
      this.$windowOpenerHelper.notifyOpener('reload_announcements_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
